import React from 'react';
import AntdProForm, { ProFormSelect } from '@ant-design/pro-form';
import ProForm from '../../layout/ProForm';
import { useQuery, gql } from '@apollo/client';
import fp from 'lodash/fp';
import RolePremissionsForm from '../roles/RolePremissionsForm';
import PropTypes from 'prop-types';

const GET_ROLES = gql`
  query GET_ROLES {
    roles(state: ALL) {
      id
      name
      scopes {
        type
        level
      }
    }
  }
`;

const getValueEnum = fp.pipe(
  fp.get(`roles`),
  fp.reduce((acc, { id, name }) => {
    acc[id] = name;
    return acc;
  }, {})
);

const RoleForm = ({ onFinish, initialValues }) => {
  const [form] = AntdProForm.useForm();
  const { data, loading } = useQuery(GET_ROLES);
  return (
    !loading && (
      <ProForm form={form} onFinish={onFinish} initialValues={initialValues}>
        <ProFormSelect
          showSearch
          label="Role"
          name="role"
          key="role"
          width="xl"
          placeholder="select"
          valueEnum={data ? getValueEnum(data) : {}}
          rules={[
            {
              required: true,
              message: 'please select',
            },
          ]}
        />
        <RolePremissionsForm
          includeReportControlType={false}
          includeViewProject={false}
          showSystemwiseSetting={false}
        />
      </ProForm>
    )
  );
};

RoleForm.defaultProps = {
  initialValues: {},
};

RoleForm.propTypes = {
  onFinish: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
};

export default RoleForm;
